
import './EditProfileFormContainer.scss';
export default function EditProfileFormContainer(props: any) {
    return (
        <div className="sc-cBOTKl bcJSxL thisone">{props.children}</div>
    );
}